import React from 'react';
import styles from './Header.module.css';
import Logo from "../Logo";

const Header: React.FC = () => {
  return (
    <header className={styles.header} role="banner">
        <Logo />
    </header>
  );
};

export default Header;
